import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import LanguagePage from "@/pages/LanguagePage";
import CategoryPage from "@/pages/CategoryPage";
import ComposePage from "@/pages/ComposePage";
import SubmitPage from "@/pages/SubmitPage";
import PoliciesPage from "@/pages/PoliciesPage";
import AuthPage from "@/pages/AuthPage";
import HistoryPage from "@/pages/HistoryPage";

const RequireLang = ({ children }) => {
  const { language } = useApp();
  if (!language) return <Navigate to="/" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LanguagePage />} />
      <Route path="/category" element={<RequireLang><CategoryPage /></RequireLang>} />
      <Route path="/complaint" element={<RequireLang><ComposePage /></RequireLang>} />
      <Route path="/submit" element={<RequireLang><SubmitPage /></RequireLang>} />
      <Route path="/policies" element={<RequireLang><PoliciesPage /></RequireLang>} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/history" element={<RequireLang><HistoryPage /></RequireLang>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen font-body">
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
